/*
 * Vajihi Labs - Email Signature Builder
 * Tiny module-level store for the local (device-only) logo preview blob
 * URLs — shared between Customize (where they're set) and Apply (which
 * should show the same in-progress logo). Never persisted, never used for
 * the real export/insert path: a blob: URL fails sanitizeLogoUrl anyway,
 * so even a caller that forgets to distinguish preview-vs-real degrades
 * safely rather than sending a broken reference.
 */

import type { SignatureModel } from "./themes";

let lightBlobUrl: string | null = null;
let darkBlobUrl: string | null = null;

export function setLocalLogoPreview(light: string | null, dark: string | null): void {
  lightBlobUrl = light;
  darkBlobUrl = dark;
}

export function getLocalLogoPreview(): { lightBlobUrl: string | null; darkBlobUrl: string | null } {
  return { lightBlobUrl, darkBlobUrl };
}

export function hasLocalLogoPreview(): boolean {
  return !!lightBlobUrl || !!darkBlobUrl;
}

/** Returns a display-only copy of the model with local blob previews
 *  layered over the real hosted URLs — for live-preview rendering only. */
export function withLocalLogoOverride(model: SignatureModel): SignatureModel {
  if (!lightBlobUrl && !darkBlobUrl) return model;
  return {
    ...model,
    logos: {
      ...model.logos,
      lightSurfaceUrl: lightBlobUrl || model.logos.lightSurfaceUrl,
      darkSurfaceUrl: darkBlobUrl || model.logos.darkSurfaceUrl,
    },
  };
}
